import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { path, clone, mergeDeepLeft, find, propEq } from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import TextArea from '../../common/TextArea';
import { getListOfComments, addCommentToTask, fetchTaskById } from '../../api/task';
import { fetchUsers } from '../../api/users';
import Comment from '../../common/Comment';
import { bindFieldAndData } from '../Task/data';

export class TaskComments extends Component {

  constructor(props) {
    super(props);

    this.state = {
      fields: {
        comment: {
          label: 'New Comment',
          placeholder: 'Fill-in this field',
          system: {
            name: 'new_comment',
          },
          value: '',
          errors: [],
          type: 'text',
          name: 'new_comment',
          rules: {
            title: 'New Comment',
            required: true,
          }
        }
      }
    };

    this.renderComments = this.renderComments.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.addComment = this.addComment.bind(this);
  }

  componentWillMount() {
    const id = path(['match', 'params', 'id'], this.props);

    this.props.loadComments(id);
    this.props.loadUsersList();
    this.props.getDataById(id);
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  renderComments() {
    const comments = path(['tasks', 'comments'], this.props);
    const users = path(['users', 'userList'], this.props);
    const arrComments = [];

    if (comments && comments.length > 0 && users && users.length > 0) {
      for (let i = 0; i < comments.length; i++) {
        arrComments.push(<Comment data={comments[i]} />);
      }
    }

    return arrComments;
  }

  addComment() {
    const id = path(['match', 'params', 'id'], this.props);

    this.props.sendComment(id, {
      content: path(['fields', 'comment', 'value'], this.state) || '',
    });

    let stateClone = clone(this.state);
    stateClone.fields.comment.value = '';
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  render() {
    const id = path(['match', 'params', 'id'], this.props);

    const fields = path(['tasks', 'current', 'fields'], this.props);
    const fields_detail = path(['tasks', 'current', 'fields_detail'], this.props);
    let taskLabel = 'Task';

    if (fields && fields_detail) {
      const data = bindFieldAndData(fields, fields_detail);
      const woField = find(propEq('label', 'Work Order'), data);
      if (woField && woField.content) {
        taskLabel = `Task ${woField.content}`;
      }
    }

    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
         { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
         { url: '/pages/task/' + id, icon: 'library_books', name: taskLabel },
         { icon: 'mode_comment', name: 'Add Comment' },
        ]} />
        <TextArea
          field={this.state.fields['comment']}
          onChange={this.changeFormValue}
        />
        <button className="btn btn-rounded btn-icon ui-btn pull-right" onClick={this.addComment}>
          <i className="material-icons">mode_comment</i>
          <span className="color-default">Add</span>
        </button>
        <div style={{ paddingTop: '50px' }}>
          {this.renderComments()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDataById: (id) => {
      fetchTaskById(id)(dispatch);
    },
    loadComments: (id) => {
      getListOfComments(id)(dispatch);
    },
    loadUsersList: () => {
      fetchUsers()(dispatch);
    },
    sendComment: (id, data) => {
      addCommentToTask(id, data)(dispatch);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskComments);



// WEBPACK FOOTER //
// ./src/containers/TaskComments/index.js